import type { TabProps } from './Tabs.types';

export default function Tab(props: TabProps) {
  const { ref, icon, label, isActive, onClick } = props;

  let iconColorClassName =
    'text-pmw-icon-fill-secondary-light dark:text-pmw-icon-fill-secondary-dark';
  let textColorClassName = 'text-pmw-label-secondary-light dark:text-pmw-label-secondary-dark';

  if (isActive) {
    iconColorClassName = 'text-pmw-icon-fill-primary-light dark:text-pmw-icon-fill-primary-dark';
    textColorClassName = 'text-pmw-label-primary-light dark:text-pmw-label-primary-dark';
  }

  return (
    <button
      ref={ref}
      type="button"
      role="tab"
      className="relative py-[8px] px-[16px] flex-1 flex flex-col gap-[2px] items-center justify-center whitespace-nowrap cursor-pointer"
      onClick={onClick}
    >
      <span className={iconColorClassName}>{icon}</span>
      <span className={`font-robotoBold text-[14px] ${textColorClassName}`}>{label}</span>

      {isActive && (
        <div className="absolute left-0 right-0 bottom-0 h-[3px] bg-pmw-tab-active dark:bg-pmw-tab-active-dark" />
      )}
    </button>
  );
}
